import { FC, ReactElement, ReactNode } from 'react';
import styles from './styles.module.scss';
import { MainButton } from '@/shared/ui/Buttons/MainButton';
import { CardBlank } from '@/shared/ui/CardBlank';

interface Props {
  Icon: string;
  children: ReactNode;
  buttonTitle?: ReactElement;
  buttonId?: string;
  buttonHandler?: () => void;
}

export const FeatureCard: FC<Props> = ({
  buttonId,
  Icon,
  children,
  buttonTitle,
  buttonHandler,
}) => {
  return (
    <CardBlank className={styles.card}>
      <div className={styles.contentWrapper}>
        <div className={styles.imageWrapper}>
          <Icon />
        </div>
        {children}
      </div>
      {!!buttonTitle && !!buttonId && !!buttonHandler && (
        <MainButton id={buttonId} text={buttonTitle} onClick={buttonHandler} />
      )}
    </CardBlank>
  );
};
